import React from "react";
import { Col } from "react-bootstrap";
import {
  ResponsiveContainer,
  LineChart,
  ReferenceLine,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Label,
} from "recharts";
import { CalendarWeek } from "shared/utils";
import _isEmpty from "lodash/isEmpty";
import StartupDashboardWidget from "./StartupDashboardWidget";

export default class WeeklySalesChartWidget extends React.Component {
  render() {
    const { productLineAnalytics } = this.props;
    if (!productLineAnalytics) {
      return <WeeklySalesChartWidgetForFetchingData />;
    }

    const {
      absolute_sales_count_per_store_per_week_chart_data:
        absoluteSalesCountPerStorePerWeekChartData,
    } = productLineAnalytics;

    if (
      !absoluteSalesCountPerStorePerWeekChartData ||
      _isEmpty(absoluteSalesCountPerStorePerWeekChartData)
    ) {
      return <WeeklySalesChartWidgetForNonExistingData />;
    }

    const averageSalesCountPerStorePerWeekChartData =
      absoluteSalesCountPerStorePerWeekChartData.reduce((sum, { value }) => {
        return sum + (value || 0);
      }, 0) / Object.keys(absoluteSalesCountPerStorePerWeekChartData).length;

    return (
      <WeeklySalesChartWidgetContainer style={{ minHeight: "485px" }}>
        <Col md={12} style={{ minHeight: "485px", height: "485px" }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={absoluteSalesCountPerStorePerWeekChartData}
              margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
            >
              <XAxis
                dataKey="date"
                interval="preserveStartEnd"
                height={80}
                tick={<CustomizedAxisTick />}
              />
              <YAxis fontSize={12}>
                <Label angle={270} fontSize={12} dx={-15}>
                  Anzahl der Abverkäufe
                </Label>
              </YAxis>
              <CartesianGrid strokeDasharray="3 3" />
              <Line
                type="monotone"
                isAnimationActive={false}
                dataKey="value"
                stroke="#1b66b3"
                stroke-width={3}
                dot={{ strokeWidth: 2 }}
                label={<CustomizedLabel />}
              />
              <ReferenceLine
                y={averageSalesCountPerStorePerWeekChartData}
                stroke="#000"
                strokeDasharray="3 3"
                isFront
                label="∅ Abverkäufe pro Woche"
              />
              <Tooltip content={<CustomLineChartTooltipContent />} />
            </LineChart>
          </ResponsiveContainer>
        </Col>
      </WeeklySalesChartWidgetContainer>
    );
  }
}

const WeeklySalesChartWidgetContainer = props => (
  <StartupDashboardWidget
    id="weekly-sales-chart-widget"
    header={<WeeklySalesChartWidgetHeader />}
    subHeader={<WeeklySalesChartWidgetSubHeader />}
    {...props}
  >
    {props.children}
  </StartupDashboardWidget>
);

const WeeklySalesChartWidgetHeader = () => (
  <span className="dashboard-box-header-title">
    Gesamtabverkauf kumuliert pro Woche
  </span>
);

const WeeklySalesChartWidgetSubHeader = () => (
  <span className="text-right pull-right">Letzten 12 Wochen</span>
);

const WeeklySalesChartWidgetForFetchingData = () => (
  <WeeklySalesChartWidgetContainer>
    <Col md={12}>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        Daten werden geladen ...
      </div>
    </Col>
  </WeeklySalesChartWidgetContainer>
);

const WeeklySalesChartWidgetForNonExistingData = () => (
  <WeeklySalesChartWidgetContainer>
    <Col md={12}>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        Keine Abverkaufszahlen vorhanden
      </div>
    </Col>
  </WeeklySalesChartWidgetContainer>
);

const CustomizedLabel = ({ x, y, stroke, value }) => (
  <text x={x} y={y} dy={-7} fill={stroke} fontSize={12} textAnchor="middle">
    {Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(value)}
  </text>
);

const CustomizedAxisTick = ({ x, y, payload }) => {
  const dateFormatter = new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "short",
  });
  const date = new Date(payload.value);

  return (
    <text x={x} y={y} dy={16} fill="#666" fontSize={10} textAnchor="middle">
      {`${dateFormatter.format(date)} (KW ${CalendarWeek(date)})`}
    </text>
  );
};

const CustomLineChartTooltipContent = props => {
  if (!props.active) {
    return null;
  }

  const { payload, label } = props;
  const date = new Date(label);

  return (
    <div className="weekly-sales-chart-widget-tooltip">
      <p className="weekly-sales-chart-widget-tooltip-header">
        Abverkäufe in KW {CalendarWeek(date)}
      </p>
      <p className="weekly-sales-chart-widget-tooltip-value">
        {payload[0].value}
      </p>
    </div>
  );
};
